module.exports = __webpack_public_path__ + "img/plexus-2-smal.a6c5818b.png";